/**
 * 韩文词条（key 与 dict.ts 一一对应；类型为 Record<DictKey, string>，漏翻会编译报错）。
 * 占位符 {name} 与中/英文保持一致。
 */
import type { DictKey } from './dict';

export const KO: Record<DictKey, string> = {
  'app.name': 'Bluplanet',
  'home.title': '홈',
  'home.publishRfq': '견적 요청',
  'home.publishRfqDesc': '여러 품목을 한 번에 요청하고 빠르게 견적을 받으세요',
  'home.hot': '제철 추천',
  'home.viewDetail': '상세 보기',
  'home.search': '농산물, 원산지, 품목 검색',
  'home.selected': '엄선 농산물',
  'home.workbench': '내 워크스페이스',
  'home.noMatch': '일치하는 상품이 없습니다',
  'home.categoryAll': '전체',
  'banner.fallbackTitle': '엄선된 농산물, 산지에서 바로',
  'banner.fallbackSubtitle': '산지 직송 · 콜드체인 실시간 확인 · 빠른 견적',
  'profile.title': '회사 정보 등록',
  'profile.desc': '회사 정보를 입력하시면 더 정확한 견적을 받으실 수 있습니다',
  'profile.company': '회사명',
  'profile.contact': '담당자',
  'profile.country': '국가/지역',
  'profile.phone': '연락처',
  'profile.companyRequired': '회사명을 입력해 주세요',
  'profile.saveFailed': '저장에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'profile.skip': '나중에',
  'profile.save': '저장',
  'profile.changePassword': '비밀번호 변경',
  'profile.changePwdTitle': '비밀번호 변경',
  'profile.changePwdDesc': '계정 보안을 위해 비밀번호를 주기적으로 변경해 주세요.',
  'profile.oldPassword': '현재 비밀번호',
  'profile.newPassword': '새 비밀번호',
  'profile.confirmPassword': '새 비밀번호 확인',
  'profile.oldPwdRequired': '현재 비밀번호를 입력해 주세요',
  'profile.newPwdMin': '새 비밀번호는 6자 이상이어야 합니다',
  'profile.pwdMismatch': '새 비밀번호가 일치하지 않습니다',
  'profile.pwdSame': '새 비밀번호는 현재 비밀번호와 달라야 합니다',
  'profile.pwdChanged': '비밀번호가 변경되었습니다',
  'profile.entry': '회사 정보 등록',
  'profile.todo': '미완료',
  'inquiry.title': '견적 요청',
  'inquiry.items': '요청 품목',
  'inquiry.addItem': '품목 추가',
  'inquiry.removeItem': '삭제',
  'inquiry.bindSpu': '상품 연결 (선택, 비워 두면 직접 입력)',
  'inquiry.productName': '품명',
  'inquiry.spec': '규격',
  'inquiry.packaging': '포장',
  'inquiry.quantity': '수량',
  'inquiry.unit': '단위',
  'inquiry.tradeTerm': '무역 조건',
  'inquiry.destCountry': '도착 국가',
  'inquiry.destPort': '도착항',
  'inquiry.destFree': '도착지 (직접 입력)',
  'inquiry.expectDate': '희망 납기',
  'inquiry.message': '추가 요청 (규격, 납기, 도착항 등)',
  'inquiry.submit': '견적 요청 제출',
  'inquiry.save': '변경 사항 저장',
  'inquiry.withdraw': '철회',
  'inquiry.withdrawTitle': '견적 요청 철회',
  'inquiry.withdrawConfirm': '철회하면 더 이상 처리되지 않으며 복구할 수 없습니다. 철회하시겠습니까?',
  'inquiry.cancel': '취소',
  'inquiry.updateFailed': '저장에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'inquiry.loadFailed': '견적 요청을 불러오지 못했습니다. 목록으로 돌아가 다시 시도해 주세요',
  'inquiry.statusWithdrawn': '철회됨',
  'inquiry.submitted': '견적 요청이 제출되었습니다',
  'inquiry.submittedDesc': '무역 담당자가 곧 정식 견적을 보내드립니다. 「내 견적 요청」에서 진행 상황을 확인하세요.',
  'inquiry.viewMine': '내 견적 요청 보기',
  'inquiry.needLogin': '견적 요청 전에 로그인해 주세요',
  'inquiry.qtyPositive': '각 품목의 수량은 0보다 커야 합니다',
  'inquiry.atLeastOne': '품목을 하나 이상 추가해 주세요',
  'inquiry.category': '품목군',
  'inquiry.categoryNew': '+ 품목군 추가',
  'inquiry.productSearch': '상품명 (목록에서 선택하거나 입력해 검색)',
  'inquiry.rowsTitle': '요청 항목 (항목별 견적)',
  'inquiry.rowPrefix': '',
  'inquiry.rowSuffix': '행',
  'inquiry.pickSku': '상품 / 규격 (SKU)',
  'inquiry.pickSkuBtn': '카탈로그에서 선택',
  'inquiry.edit': '변경',
  'inquiry.quantityTon': '수량 (톤)',
  'inquiry.innerPack': '내포장',
  'inquiry.outerPack': '외포장',
  'inquiry.pallet': '팔레트 여부',
  'inquiry.palletYes': '팔레트 포함',
  'inquiry.palletNo': '팔레트 없음',
  'inquiry.addRow': '+ 항목 추가',
  'inquiry.packOther': '+',
  'inquiry.packEditCustom': '눌러서 맞춤 포장 수정',
  'inquiry.packCustom': '맞춤 포장',
  'inquiry.pickConfirm': '선택',
  'inquiry.pickedCount': '외 {n}개 상품',
  'inquiry.pickEmpty': '이 품목군에는 상품이 없습니다. 상품명에 원하는 내용을 직접 입력해 주세요',
  'inquiry.rowNeedsProduct': '각 항목마다 카탈로그 상품을 선택하거나 요청 내용을 입력해 주세요',
  'inquiry.pickSearchPh': '이름/규격/코드로 검색, 비워 두면 전체 표시',
  'inquiry.pickCustom': '직접 입력한 이름으로 등록',
  'inquiry.pickAllSku': '카탈로그에서 선택',
  'inquiry.innerNetWeight': '내포장 1개당 순중량 (g, 선택)',
  'inquiry.outerNetWeight': '박스당 순중량 (kg, 선택)',
  'inquiry.innerNetPh': '예: 500 = 봉지당 500g',
  'inquiry.outerNetPh': '예: 10 = 박스당 10kg',
  'register.title': '바이어 계정 만들기',
  'register.email': '이메일',
  'register.code': '인증번호',
  'register.sendCode': '인증번호 받기',
  'register.resend': '다시 받기',
  'register.password': '비밀번호',
  'register.confirmPwd': '비밀번호 확인',
  'register.company': '회사명',
  'register.contact': '담당자명',
  'register.country': '국가',
  'register.submit': '가입하고 로그인',
  'register.haveAccount': '계정이 있으신가요? 로그인',
  'register.codePh': '6자리 숫자',
  'register.emailRequired': '이메일을 입력해 주세요',
  'register.emailInvalid': '이메일 형식이 올바르지 않습니다',
  'register.code6': '6자리 인증번호를 입력해 주세요',
  'register.sendFailed': '인증번호 발송에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'register.failed': '가입에 실패했습니다. 다시 시도해 주세요',
  'register.failedRetry': '가입에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'login.welcome': '다시 오신 것을 환영합니다',
  'login.subtitle': '바이어 통합 포털 — 가입한 이메일로 로그인하세요',
  'login.email': '이메일',
  'login.emailPh': '이메일을 입력하세요',
  'login.pwd': '비밀번호',
  'login.pwdPh': '비밀번호를 입력하세요',
  'login.remember': '로그인 상태 유지',
  'login.submit': '로그인',
  'login.errEmpty': '이메일과 비밀번호를 입력해 주세요',
  'login.errFail': '로그인에 실패했습니다. 계정 또는 비밀번호를 확인해 주세요',
  'login.errRetry': '로그인에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'login.featuresTitle': 'Bluplanet을 선택하는 이유',
  'login.brandDesc': '농산물 국경 간 거래의 엔드투엔드 파트너. 산지에서 문 앞까지, 모든 단계를 보장합니다.',
  'login.f1t': '엔드투엔드 이행',
  'login.f1d': '산지 직송 · 콜드체인 배송',
  'login.f2t': '실시간 IoT 추적',
  'login.f2d': '전 구간 온습도 확인',
  'login.f3t': '무역 신용 보장',
  'login.f3d': '중국수출신용보험 지원 · 서류 보관 증명',
  'register.pwdMismatch': '비밀번호가 일치하지 않습니다',
  'register.pwdTooShort': '비밀번호는 6자 이상이어야 합니다',
  'register.codeSent': '인증번호를 보냈습니다 (60초간 유효)',
  'register.sending': '발송 중…',
  'common.backHome': '홈으로',
  'common.lang': '한',
  'common.currency': '통화',
  'nav.home': '홈',
  'nav.products': '전체 상품',
  'nav.services': '서비스',
  'nav.tabInquiry': '견적',
  'nav.login': '로그인',
  'nav.register': '회원가입',
  'nav.myOrders': '내 주문',
  'nav.profile': '마이페이지',
  'nav.myInquiries': '내 견적 요청',
  'nav.myClaims': '내 클레임',
  'nav.messages': '알림함',
  'nav.logout': '로그아웃',
  'nav.ai': '실시간 상담',
  'nav.ordersCenter': '주문',
  'nav.orderDetail': '주문 상세',
  'nav.productDetail': '상품 상세',
  'nav.buyNow': '바로 구매',
  'nav.tabOrders': '주문',
  'nav.tabMe': '마이',
  'common.back': '뒤로',
  'hero.label': '산지 직송 · 콜드체인 실시간 확인',
  'hero.title1': '엄선된 농산물을',
  'hero.title2': '산지에서 문 앞까지',
  'hero.desc': '통관 서류 완비 · 1:1 무역 담당자 · 17단계 이행 과정 확인',
  'hero.cta1': '견적 요청',
  'hero.cta2': '상품 둘러보기',
  'trust.ports': '도착항',
  'trust.nodes': '이행 단계',
  'trust.cats': '판매 품목',
  'trust.advisor': '무역 담당자',
  'home.categories': '품목별 보기',
  'home.allCats': '전체',
  'home.viewMore': '더 보기',
  'home.inquire': '견적 문의',
  'home.unitTon': '/톤',
  'home.unitKg': '/kg',
  'home.priceOnRequest': '가격 문의',
  'common.loading': '불러오는 중…',
  'product.notFound': '상품을 찾을 수 없습니다',
  'product.pickSpec': '규격 선택',
  'product.pickSpecCount': '규격 선택 (총 {n}종)',
  'product.spec': '규격',
  'product.noSku': '판매 중인 규격이 없습니다',
  'product.perTonFrom': '/톤부터',
  'product.inquireQuote': '견적 요청하기',
  'product.buyNow': '바로 구매',
  'product.loginPromptTitle': '로그인 후 견적 요청 또는 주문이 가능합니다',
  'product.loginPromptDesc': '바이어 계정으로 로그인하면 정식 견적을 요청하거나 바로 주문할 수 있습니다.',
  'inquiry.containerEst': '컨테이너 약 {n}개 (컨테이너당 {q}톤)',
  'inquiry.byTon': '톤 기준',
  'inquiry.byCarton': '박스 기준',
  'inquiry.quantityCarton': '수량 (박스)',
  'inquiry.quantityTonHint': '상품 순중량 (포장 및 팔레트 제외)',
  'inquiry.quantityCartonHint': '박스 수로 입력하며, 박스당 순중량으로 톤수를 환산합니다',
  'inquiry.cartonNeedWeight': '먼저 박스당 순중량을 입력해 주세요',
  'inquiry.cartonEst': '≈ {n}박스{rest}',
  'inquiry.cartonRemainder': ' (잔여 {kg}kg)',
  'inquiry.tonEst': '≈ {t}톤 (순중량)',
  'product.priceLabel': '시세 참고가',
  'product.priceTBD': '가격 문의 (무역 담당자에게 문의하세요)',
  'home.specCount': '개 규격 선택 가능',
  'service.title': '서비스 & 보장',
  'service.s1t': '산지 직송',
  'service.s1d': '생산지에서 직접, 중간 유통 없이',
  'service.s2t': '콜드체인 실시간 확인',
  'service.s2d': '온도 실시간 추적',
  'service.s3t': '통관 서류 완비',
  'service.s3d': '식물검역증·원산지증명서 일괄 처리',
  'service.s4t': '이행 보장',
  'service.s4d': '클레임 처리 전 과정 추적',
  'footer.slogan': '농산물 국경 간 거래의 엔드투엔드 파트너. 산지에서 문 앞까지, 모든 단계를 보장합니다.',
  'footer.contact': '문의하기',
  'auth.browseAround': '둘러보기',
  'auth.goLogin': '로그인',
  'auth.promptDesc': '로그인하면 견적 요청, 주문, 주문 관리까지 국경 간 이행 서비스를 모두 이용할 수 있습니다.',
  'auth.promptTitle': '계속하려면 로그인해 주세요',
  'claim.amount': '청구 금액',
  'claim.applyPayout': '보상 신청',
  'claim.back': '‹ 뒤로',
  'claim.backToCenter': '클레임 센터로 돌아가기',
  'claim.cancel': '취소',
  'claim.center': '클레임 센터',
  'claim.deductible': '공제액',
  'claim.desc': '클레임 내용 (20자 이상)',
  'claim.detail': '클레임 상세',
  'claim.dialogTitle': '이의 제기 / 클레임',
  'claim.durationFor': '지속',
  'claim.evidenceChain': '증거 체인 (IoT 데이터 기반 책임 판정)',
  'claim.history': '클레임 내역',
  'claim.liabilitySplit': '책임 분담',
  'claim.noEvidence': '증거 데이터가 없습니다',
  'claim.noLiability': '책임 판정 데이터가 없습니다',
  'claim.noLogs': '처리 기록이 없습니다',
  'claim.noOrder': '주문이 없습니다',
  'claim.notFound': '클레임을 찾을 수 없습니다',
  'claim.order': '주문',
  'claim.payoutRatio': '보상 비율',
  'claim.progress': '처리 진행 상황',
  'claim.promise1': '48시간 내 응답',
  'claim.promise2': '14일 내 보상',
  'claim.promise3': '데이터 기반 책임 판정',
  'claim.promiseTitle': '🛡 BluGuard 클레임 약속',
  'claim.raiseBtn': '이의 제기 / 클레임 신청',
  'claim.relateOrder': '관련 주문',
  'claim.ruleSnapshot': '적용 규칙 스냅샷',
  'claim.statActive': '처리 중',
  'claim.statClosed': '종결',
  'claim.statPaid': '보상 완료',
  'claim.submit': '제출',
  'claim.subtitle': 'BluGuard 스마트 클레임',
  'claim.tempThreshold': '온도 초과 기준',
  'claim.type': '클레임 유형',
  'claim.viewDetail': '상세 보기 ›',
  'claim.whatsapp': '💬 WhatsApp 전담 상담',
  'comp.chatCustomer': '나',
  'comp.chatStaff': '상담',
  'comp.creditAvailable': '사용 가능 한도',
  'comp.creditInUse': '사용 중',
  'comp.creditNextDue': '다음 만기',
  'comp.creditRating': '신용 등급',
  'comp.creditRatingBadge': '등급',
  'comp.creditTitle': 'BluCredit 신용 결제 기간',
  'comp.creditTotal': '총 한도',
  'comp.lanbaoFabLabel': '블루 AI',
  'doc.attachment': '첨부파일',
  'doc.carbonReduction': '탄소 감축',
  'doc.catAll': '전체',
  'doc.catArrival': '도착',
  'doc.catCertPack': '증명서 패키지',
  'doc.catOther': '기타',
  'doc.catTempControl': '온도 관리',
  'doc.compliant': '기준 충족',
  'doc.days': '일',
  'doc.download': '다운로드',
  'doc.receiverPlan': '수금 계획',
  'doc.remaining': '남음',
  'doc.shaHash': 'SHA-256 검증 해시',
  'doc.slipNo': '입금 전표 번호',
  'doc.uploadSlip': '입금 전표 업로드',
  'doc.uploaded': '업로드 완료',
  'footer.brandMark': 'B',
  'fulfill.bluGuardPlan': 'BluGuard 대응 계획 가동',
  'fulfill.brand': 'BluPlanet',
  'fulfill.contact': 'WhatsApp으로 BluPlanet 팀에 문의',
  'fulfill.containerNo': '컨테이너 번호',
  'fulfill.currentLocation': '현재 위치',
  'fulfill.currentStage': '현재 단계',
  'fulfill.currentTemp': '현재 온도',
  'fulfill.day': '일',
  'fulfill.daysAgo': '일 전',
  'fulfill.demo': '데모 데이터',
  'fulfill.departurePort': '출발항',
  'fulfill.destinationPort': '도착항',
  'fulfill.disclaimer': 'BluPlanet에서 생성한 링크 · 주문 이행 확인용 · 관계없는 사람에게 공유하지 마세요',
  'fulfill.documents': '서류',
  'fulfill.eta': '도착 예정',
  'fulfill.freq': '10분 간격 · 저장 후 전송',
  'fulfill.hour': '시간',
  'fulfill.hoursAgo': '시간 전',
  'fulfill.inTemp': '컨테이너 내부 온도',
  'fulfill.iotCurve': 'IoT 온도 곡선',
  'fulfill.justNow': '방금',
  'fulfill.loadedAfter': '적재 후',
  'fulfill.locating': '위치 확인 중',
  'fulfill.min': '분',
  'fulfill.minutesAgo': '분 전',
  'fulfill.noDocuments': '서류가 없습니다',
  'fulfill.noDownloadPerm': '다운로드 권한이 없습니다. 관리자에게 문의해 주세요.',
  'fulfill.noRt': '실시간 데이터 없음',
  'fulfill.noTracking': '아직 이행 기록이 없습니다',
  'fulfill.nodePhoto': '사진',
  'fulfill.nodeProgress': '10단계 진행 상황',
  'fulfill.nodeVideo': '영상',
  'fulfill.now': '현재',
  'fulfill.orderNo': '주문 번호',
  'fulfill.orderNotFound': '주문을 찾을 수 없습니다',
  'fulfill.overLimit': '초과',
  'fulfill.overLimitDuration': '초과 지속 시간',
  'fulfill.progress': '진행률',
  'fulfill.ribbon': '콜드체인 밴드 · 전 항해 온도 상태',
  'fulfill.ribbonBreach': '초과',
  'fulfill.ribbonOk': '기준 충족',
  'fulfill.noStandard': '온도 기준 미설정',
  'fulfill.noStandardStats': '이 상품은 온도 기준이 설정되지 않아 충족률을 집계하지 않습니다',
  'fulfill.shippingCompany': '선사',
  'fulfill.target': '목표',
  'fulfill.targetBand': '목표 범위',
  'fulfill.targetTemp': '목표 온도',
  'fulfill.tempLabel': '온도',
  'fulfill.tempOk': '정상',
  'fulfill.tempOver': '온도 초과',
  'fulfill.tracking': '이행 진행 추적',
  'fulfill.updated': '업데이트',
  'fulfill.uploadedAt': '업로드',
  'fulfill.upperLimit': '상한',
  'fulfill.alarmLow': '하한',
  'fulfill.alarmHigh': '상한',
  'fulfill.alarmRange': '경보 범위',
  'fulfill.tempBandOk': '기준 충족',
  'fulfill.tempDeviate': '이탈',
  'fulfill.tempAlarm': '경보',
  'fulfill.ribbonDeviate': '이탈',
  'fulfill.ribbonAlarm': '경보',
  'fulfill.vessel': '선박명',
  'inquiry.catSwitchHint': ' (아래 품목군을 눌러 변경)',
  'inquiry.currentCat': '현재 품목군: ',
  'inquiry.destLabel': '도착지: ',
  'inquiry.freeDesc': '직접 입력',
  'inquiry.listEmpty': '아직 견적 요청이 없습니다. 홈에서 농산물을 골라 요청해 보세요.',
  'inquiry.listLoginHint': '로그인하면 견적 요청 내역을 볼 수 있습니다.',
  'inquiry.moreItemsPrefix': ' 외 ',
  'inquiry.moreItemsSuffix': '개 품목',
  'inquiry.moreItemsTotalPrefix': '… 총 ',
  'inquiry.packCalciumBox': '칼슘 플라스틱 박스',
  'inquiry.packCarton': '종이 박스',
  'inquiry.packFoamBox': '스티로폼 박스',
  'inquiry.packNetBag': '망 포대',
  'inquiry.packNone': '없음',
  'inquiry.packPlasticBasket': '플라스틱 상자',
  'inquiry.packVacuumBag': '진공 포장',
  'inquiry.productFallback': '상품',
  'inquiry.quoteNo': '번호',
  'inquiry.quoteReply': '견적 회신: ',
  'inquiry.refPriceLabel': '참고가',
  'inquiry.statusOrdered': '주문 전환됨',
  'inquiry.statusPending': '회신 대기',
  'inquiry.statusProcessing': '처리 중',
  'inquiry.createNew': '새 견적 요청',
  'inquiry.statusQuoted': '견적 완료',
  'inquiry.submitFailed': '제출에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'inquiry.targetTermLabel': '무역 조건: ',
  'inquiry.unitPrice': '단가',
  'inquiry.unitTon': '톤',
  'inquiry.viewQuoteOrder': '견적 확인 후 주문',
  'message.empty': '아직 알림이 없습니다. 견적 회신이 오면 여기에 표시됩니다',
  'message.loadFailed': '불러오지 못했습니다',
  'message.loginToView': '로그인 후 알림을 확인할 수 있습니다',
  'message.notification': '알림',
  'message.titleInquirySubmitted': '견적 요청 제출됨',
  'message.titleInquiryReply': '견적 요청에 대한 견적이 도착했습니다',
  'message.titleQuoteAccepted': '견적서 확인 완료',
  'message.titleOrderCreated': '견적서가 주문으로 전환되었습니다',
  'message.typeInquiryReply': '견적 회신',
  'message.typeInquiryStatus': '견적 요청 상태',
  'message.typeSystem': '시스템 알림',
  'message.typeOrder': '주문 알림',
  'order.about': '약',
  'order.buyerCenterOverview': '바이어 센터 · 계정 개요',
  'order.confirmOrder': '주문 확정',
  'order.containers': '컨테이너',
  'order.createFailed': '주문에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'order.createSuccess': '주문 완료',
  'order.creditRating': '신용 등급',
  'order.due': '만기',
  'order.fullContainerUnit': '개 컨테이너(FCL)',
  'order.historyLabel': '지난 주문',
  'order.inTransitAmount': '진행 중 금액',
  'order.inTransitLabel': '진행 중 주문',
  'order.noDocuments': '서류가 없습니다',
  'order.notFound': '주문을 찾을 수 없습니다',
  'order.note': '비고',
  'order.paidAmount': '결제 금액',
  'order.payPendingVerify': '확인 대기',
  'order.payRejected': '반려됨',
  'order.payToUpload': '업로드 대기',
  'order.payUnpaid': '결제 대기',
  'order.payVerified': '확인 완료',
  'order.paymentMethod': '결제 방식',
  'order.paymentVoucher': '결제 증빙',
  'order.perContainer': '컨테이너당',
  'order.qtyGtZero': '수량은 0보다 커야 합니다 (단위: 톤)',
  'order.quickEstimate': '빠른 예상 (상품 보관·운송 속성 기준)',
  'order.statusCancelled': '취소됨',
  'order.statusCompleted': '완료',
  'order.statusConfirmed': '상품 준비 중',
  'order.statusDelivered': '배송 완료',
  'order.statusExportCustoms': '수출 통관',
  'order.statusImportCustoms': '수입 통관',
  'order.statusPending': '확인 대기',
  'order.statusShipping': '해상 운송 중',
  'order.subDocuments': '서류',
  'order.subPayment': '결제',
  'order.subTracking': '추적',
  'order.submitFailed': '제출에 실패했습니다. 잠시 후 다시 시도해 주세요',
  'order.tempAlert': '온도 경보',
  'order.tons': '톤',
  'order.unitPriceLabel': '단가',
  'order.viewInOrders': '주문에서 보기',
  'order.voucherSubmittedHint': '증빙 파일이 제출되어 확인 중입니다',
  'order.voucherSubmittedOk': '결제 증빙이 제출되었습니다. 확인을 기다리고 있습니다',
  'profile.accountSettings': '계정 및 설정',
  'profile.avatarFallback': 'B',
  'profile.buyerCode': '바이어 코드',
  'profile.creditRating': '신용 등급',
  'profile.guestName': '바이어',
  'profile.joinDate': '가입일',
  'quote.buyer': '바이어',
  'quote.confirmFailed': '주문 확정에 실패했습니다. 다시 시도해 주세요',
  'quote.contactCountry': '담당자 / 국가',
  'quote.convertedHint': '이 견적서는 주문으로 전환되었습니다. 「내 주문」에서 이행 상황을 확인하세요.',
  'quote.costBreakdown': '비용 내역',
  'quote.createdAt': '작성일',
  'quote.customsClearanceFee': '통관 수수료',
  'quote.docFee': '서류 수수료',
  'quote.domesticTransport': '국내 운송비',
  'quote.inlandDeliveryFee': '도착국 내륙 배송비',
  'quote.insuranceFee': '보험료',
  'quote.invalid': '유효하지 않은 견적서',
  'quote.itemDetails': '품목 상세',
  'quote.lines': '행',
  'quote.loadFailed': '불러오지 못했습니다',
  'quote.oceanFreight': '해상 운임',
  'quote.pendingPrice': '가격 미정',
  'quote.placing': '주문 중…',
  'quote.portMiscFee': '항만 부대비용',
  'quote.product': '상품',
  'quote.qtyUnit': '수량 / 단위',
  'quote.reviewHint': '견적 내역을 확인한 후 주문을 확정해 주세요',
  'quote.route': '항로',
  'quote.deliveryPlace': '인도 장소',
  'quote.settleCurrency': '결제 통화',
  'quote.statusAccepted': '수락됨',
  'quote.statusConverted': '주문 전환됨',
  'quote.statusDraft': '초안',
  'quote.statusExpired': '만료됨',
  'quote.statusRejected': '거절됨',
  'quote.statusSent': '수락 대기',
  'quote.taxes': '세금',
  'quote.title': '견적서',
  'quote.totalAmount': '총액',
  'quote.unitPrice': '단가',
  'quote.perCarton': '≈ {v}/박스',
  'quote.cartonQty': '≈ {n}박스',
  'quote.validDays': '유효 기간(일)',
  'quote.validUntil': '견적 마감일',
  'share.buyer': '바이어',
  'share.contactCountry': '담당자 / 국가',
  'share.contactSales': '새 공유 링크는 영업 담당자에게 요청해 주세요',
  'share.costCustoms': '통관 수수료',
  'share.costDetail': '비용 내역',
  'share.costDocFee': '서류 수수료',
  'share.costDomesticTransport': '국내 운송비',
  'share.costInlandDelivery': '내륙 배송비',
  'share.costInsurance': '보험료',
  'share.costOceanFreight': '해상 운임',
  'share.costPortCharges': '항만 부대비용',
  'share.costTaxes': '세금 및 관세',
  'share.createdAt': '작성일',
  'share.currency': '결제 통화',
  'share.enter': 'Bluplanet 바이어 포털로 이동',
  'share.invalidLink': '유효하지 않은 공유 링크',
  'share.linkExpired': '링크가 만료되었습니다',
  'share.loadFailed': '주문 정보를 불러오지 못했습니다',
  'share.networkError': '네트워크 오류입니다. 잠시 후 다시 시도해 주세요',
  'share.noDocDownload': '이 공유 링크는 서류 다운로드가 허용되지 않습니다. 관리자에게 문의해 주세요.',
  'share.product': '상품',
  'share.qtyUnit': '수량 / 단위',
  'share.quotationInvalid': '유효하지 않은 공유 링크',
  'share.quotationLoadFailed': '불러오지 못했습니다',
  'share.quotationSub': '공유 링크로 이 견적서를 보고 있습니다 (로그인 불필요)',
  'share.quotationTitle': '견적서',
  'share.route': '항로',
  'share.deliveryPlace': '인도 장소',
  'share.serverError': '서버 오류',
  'share.spec': '규격',
  'share.total': '총액',
  'share.tradeTerm': '무역 조건',
  'share.unitPrice': '단가',
  'share.validDays': '유효 기간(일)',
  'share.validUntil': '견적 마감일',
  'voucher.chainVerified': '✓ 모든 서류의 SHA-256이 블록체인에 기록되었습니다',
  'voucher.fileTooLarge': '파일 크기는 10MB 이하여야 합니다',
  'voucher.paidAmount': '결제 금액',
  'voucher.payerNote': '결제 메모 (선택)',
  'voucher.pdfSelected': 'PDF 증빙이 선택되었습니다. 제출 후 담당자가 확인할 수 있습니다.',
  'voucher.previewAlt': '결제 증빙 미리보기',
  'voucher.reselect': '다시 선택',
  'voucher.scanVerify': '스캔하여 검증',
  'voucher.selectFile': '증빙 이미지 / PDF 선택',
  'voucher.selectFirst': '먼저 결제 증빙을 선택해 주세요',
  'voucher.selected': '선택됨: ',
  'voucher.submit': '결제 증빙 제출',
  'voucher.submitting': '제출 중…',
  'voucher.uploadTitle': '결제 증빙 업로드',
  'voucher.verifyCardDesc': '스캔하여 서류 진위를 확인하세요',
  'voucher.verifyCardTitle': '해시 검증 카드',
  'api.badResponse': '서버 응답에 문제가 있습니다 ({status})',
  'api.requestFailed': '요청에 실패했습니다 ({code})',
  'api.sessionExpired': '로그인이 만료되었습니다. 다시 로그인해 주세요.',
  'auth.emailRequired': '이메일을 입력해 주세요',
  'chat.AI': 'AI 상담',
  'chat.CLOSED': '상담이 종료되었습니다',
  'chat.HUMAN': '상담원 연결됨',
  'chat.WAITING': '상담원 연결 대기 중입니다. 메시지를 남겨 주세요.',
  'chat.error': '연결에 실패했습니다. 다시 시도해 주세요. 작성 중인 내용은 저장되어 있습니다.',
  'chat.expired': '상담 세션이 만료되었습니다. 새 상담을 시작해 주세요.',
  'chat.human': '상담원 연결',
  'chat.placeholder': '물류, 견적, 무역 조건에 대해 물어보세요…',
  'chat.restart': '새 상담',
  'chat.send': '보내기',
  'chat.staff': '상담원',
  'chat.thinking': 'AI가 답변 중…',
  'chat.welcome': '안녕하세요! Bluplanet 무역 어시스턴트입니다. 배송 추적, 견적 요청 방법, 무역 조건 차이 등을 물어보세요.',
  'comp.clickToChatDragTo': '눌러서 상담 · 드래그해서 이동',
  'hero.getAQuote': '견적 받기',
  'hero.tellUsWhatYouNeed': '필요한 상품을 알려 주세요…',
  'home.loadMore': '더 보기',
  'home.retry': '다시 시도',
  'home.showAllCategories': '전체 품목 보기 ({count})',
  'home.showFewerCategories': '품목 접기',
  'home.unableToLoadProductsPlease': '상품을 불러오지 못했습니다. 다시 시도해 주세요.',
  'inquiry.compareQuotes': '견적 비교',
  'inquiry.sentquotescountQuoteOptions': '견적안 {sentQuotesCount}개 · ',
  'inquiry.viewConversationProgress': '상담 기록 및 진행 상황 보기',
  'inquiryText.bulkPackedNoInnerBags': '벌크 포장 (내포장 없음)',
  'inquiryText.compareAvailableRoutes': '이용 가능한 항로 비교',
  'inquiryText.notSureYet': '아직 모름',
  'inquiryText.smallerBagsInsideTheCarton': '박스 안 소포장',
  'journey.aMixedOrderNeedsA': '혼합 포장 주문은 수량을 정확히 나누기 위해 박스당 순중량을 먼저 확정해야 합니다. 박스 규격을 입력해 주세요.',
  'journey.aSimpleWayToRequest': '한 문장으로 간편하게 견적 요청',
  'journey.aboutSailingdaysSailingDays': '항해 약 {sailingDays}일',
  'journey.addADetailOrAsk': '정보를 추가하거나 블루에게 질문하세요…',
  'journey.allocatedAllocationtotalCartonsV': '배분됨: {allocationTotal}박스{total}',
  'journey.attachments': '첨부파일',
  'journey.basedOnCurrentRouteData': '현재 항로 기준으로 가장 빠른 도착 예상일은 {date}입니다 (항해 {sailingDays}일 + 처리 7일). 이 날짜 이후로 선택해 주세요.',
  'journey.basedOnCurrentRouteData2': '현재 항로 기준으로 가장 빠른 도착 예상일은 {date}이며, 최종 일정은 견적 시 확정됩니다.',
  'journey.calciumPlasticBox': '칼슘 플라스틱 박스',
  'journey.cartonStandardExport': '종이 박스 (일반 수출용)',
  'journey.cartonWeightExceedsTheSelected': '박스당 중량이 선택한 SKU 규격 범위를 벗어납니다. 중량을 조정하거나 SKU를 다시 선택해 주세요.',
  'journey.cartonsPerPackageConfiguration': '포장 구성별 박스 수',
  'journey.cfr': 'CFR',
  'journey.changeDate': '날짜 변경',
  'journey.chooseAQuoteQuoteoptionscount': '견적안 선택 ({quoteOptionsCount})',
  'journey.chooseArrivalDate': '희망 도착일 선택',
  'journey.chooseOneOrTypeYour': '선택하거나 직접 입력하세요:',
  'journey.cif': 'CIF',
  'journey.closeCalendar': '달력 닫기',
  'journey.collectedSoFar': '지금까지 정리된 정보',
  'journey.compareAvailableTerms': '가능한 조건 비교',
  'journey.compareQuoteOptions': '견적안 비교',
  'journey.compareTerms': '조건 비교',
  'journey.compareWithClarity': '한눈에 비교하는 견적',
  'journey.confirmSplit': '배분 확정',
  'journey.countMeshBagsV': '{count}개 망 포대 × {v}',
  'journey.customPackaging': '맞춤 포장: ',
  'journey.customPackagingDetailsToFollow': '맞춤 포장 요청은 추후 전달',
  'journey.describeTheNumberAndNet': '박스당 내포장 개수와 개당 순중량을 알려 주세요.',
  'journey.describeTheOuterPackagingYou': '원하시는 외포장 종류를 알려 주세요.',
  'journey.editAnyDetailBeforeSending': '제출 전에 자유롭게 수정할 수 있습니다. 납기, 무역 조건, 포장은 아직 정하지 않아도 됩니다.',
  'journey.enterKgPerCarton': '박스당 kg 입력…',
  'journey.enterTheNetWeightPer': '박스당 순중량을 입력해 주세요. 예: 박스당 8kg',
  'journey.fasterDelivery': '빠른 납기 우선',
  'journey.fewerTransfers': '환적 최소화',
  'journey.fileUploadFailedPleaseTry': '파일 업로드에 실패했습니다. 다시 시도해 주세요.',
  'journey.foamBoxDirectPack': '스티로폼 박스 (직접 포장)',
  'journey.fob': 'FOB',
  'journey.goodsTotal': '상품 총액',
  'journey.inquiryConversation': '견적 요청 상담 기록',
  'journey.inquiryConversation2': '견적 상담',
  'journey.inquirySubmitted': '견적 요청이 제출되었습니다',
  'journey.kgKgCarton': '{kg}kg / 박스',
  'journey.lowerCost': '비용 우선',
  'journey.meshBag': '망 포대',
  'journey.n10Bags1Kg': '10봉지 × 1kg',
  'journey.n10Bags1KgEach': '10봉지 × 각 1kg',
  'journey.n20Bags500G': '20봉지 × 500g',
  'journey.n20Bags500GEach': '20봉지 × 각 500g',
  'journey.newInquiry': '새 견적 요청',
  'journey.nextMonth': '다음 달',
  'journey.noLongFormsToStart': '긴 양식 없이 바로 시작',
  'journey.noOtherRequirements': '기타 요청 없음',
  'journey.noPallet': '팔레트 없음',
  'journey.noPreference': '선호 없음',
  'journey.noSkuMatchesTheseRequirements': '조건에 맞는 SKU가 없습니다. 품종/규격을 보완하거나 플랫폼 확인을 요청해 주세요.',
  'journey.notSureRecommendForMe': '잘 모르겠어요, 추천해 주세요',
  'journey.nothingMovesWithoutYourSay': '중요한 결정은 언제나 직접',
  'journey.oneLargeBagBulkPack': '대포장 1개 / 벌크',
  'journey.organizing': '정리 중…',
  'journey.originPort': '선적항',
  'journey.otherCartonSize': '다른 박스 규격',
  'journey.otherInnerBagConfiguration': '다른 내포장 규격',
  'journey.otherPack': '기타 규격',
  'journey.otherRequirements': '기타 요청: ',
  'journey.otherRequirementsToFollow': '기타 요청은 추후 전달',
  'journey.palletized': '팔레트 포함',
  'journey.pkg.cartonNet': '박스당 순중량: {weight}',
  'journey.pkg.inner': '내포장: {value}',
  'journey.pkg.outer': '외포장: {value}',
  'journey.plasticCrate': '플라스틱 상자',
  'journey.platformToRecommendSuitableOuter': '플랫폼에서 적합한 외포장 추천',
  'journey.pleaseChooseADateFrom': '달력에서 날짜를 선택하거나 「최대한 빨리」 또는 「일정 유연」을 선택해 주세요.',
  'journey.pleaseCompleteTheCartonSplit': '포장 구성별 박스 수 배분을 먼저 완료해 주세요.',
  'journey.pleaseConfirmTheResolvedProduct': '제출 전에 다시 매칭된 상품과 규격을 확인해 주세요.',
  'journey.pleaseDescribeTheCustomRequirements': '박스 크기, 로고/인쇄, 화인 등 구체적인 요청을 알려 주세요. 디자인이 아직 없으면 대략적인 내용만 적어도 됩니다.',
  'journey.pleaseEnterACartonWeight': '선택한 SKU 규격 범위 내의 박스당 순중량을 입력해 주세요.',
  'journey.pleaseEnterADestination': '도착지를 입력해 주세요',
  'journey.pleaseEnterAPositiveCarton': '포장 구성 {innerPackConfigsCount}개 각각에 0보다 큰 박스 수를 입력해 주세요.',
  'journey.preferAFormEnterDetails': '양식이 편하신가요? 항목별로 입력하기',
  'journey.previousMonth': '이전 달',
  'journey.productNameOrDescription': '상품명 또는 설명',
  'journey.quantityMustBeGreaterThan': '수량은 0보다 커야 합니다',
  'journey.quoteDetails': '견적 상세',
  'journey.quotePreparation': '견적 준비',
  'journey.recommendForMe': '추천해 주세요',
  'journey.requestAQuote': '견적 요청',
  'journey.requestReceived': '견적 요청 접수됨',
  'journey.requestedShipDate': '희망 선적일',
  'journey.requestedShipDateNotedShipmentdate': '희망 선적일을 기록했습니다: {shipmentDate}.',
  'journey.reviewOrder': '확인 후 주문',
  'journey.reviewYourInquiry': '견적 요청 내용 확인',
  'journey.seeWhatEachOfferIncludes': '견적별 포함 내용을 한눈에',
  'journey.shipDate': '희망 선적일',
  'journey.smallerBagsInsideCarton': '박스 안 소포장',
  'journey.specificationPending': '품종/규격 확인 필요',
  'journey.standardOuterPackagingNoCustomizatio': '일반 외포장, 맞춤 요청 없음',
  'journey.standardPackaging': '일반 포장',
  'journey.status.ORDERED': '주문 완료',
  'journey.status.PENDING': '접수됨',
  'journey.status.PROCESSING': '견적 준비 중',
  'journey.status.QUOTED': '견적 완료',
  'journey.status.WITHDRAWN': '철회됨',
  'journey.tellMeWhatElseWe': '견적에 반영할 다른 요청이 있으면 알려 주세요. 나중에 추가해도 됩니다.',
  'journey.tellUsOnce': '한 번만 말씀하세요',
  'journey.theCountsAddUpTo': '현재 합계는 {sum}박스이고, 요청 수량 기준으로는 약 {v}박스입니다. 박스 배분을 조정해 주세요.',
  'journey.thisDateMayBeToo': '이 날짜는 너무 이를 수 있습니다. 현재 항로 기준으로 가장 빠른 도착 예상일은 {date}입니다 (항해 {sailingDays}일 + 처리 7일).',
  'journey.ton': '톤',
  'journey.transport': '운송 선호',
  'journey.uploading': '업로드 중',
  'journey.useEarliestDate': '가장 빠른 날짜로 설정',
  'journey.useForm': '양식으로 입력',
  'journey.vOfStagescount': '{v}/{stagesCount}단계',
  'journey.valuePerCarton': '박스당 {value}',
  'journey.varietySpecificationNotSelected': '품종/규격 미선택',
  'journey.verifiedTrade': '신뢰할 수 있는 국경 간 거래',
  'journey.viewConversation': '상담 기록 보기',
  'journey.viewOrderDetails': '주문 상세 보기',
  'journey.weNoLongerAskYou': '여기서 구체적인 선사 항로를 고르실 필요는 없습니다. 운송 선호만 알려 주시면 확정 항로는 견적과 함께 안내해 드립니다.',
  'journey.weekdays': '월,화,수,목,금,토,일',
  'journey.whichPackagingMaterialWouldYou': '대포장은 어떤 포장재를 원하시나요?',
  'journey.wovenBag': '직조 포대',
  'journey.yesIHaveCustomRequirements': '맞춤 요청이 있어요',
  'journey.youStayInControl': '모든 단계를 직접 확인',
  'journey.yourDetailsAreSavedAs': '요청 정보가 정리되었습니다',
  'journeyCopy.acceptOrder': '견적 수락 및 주문',
  'journeyCopy.accepting': '처리 중…',
  'journeyCopy.ack': '알겠습니다. 대화하면서 요청 내용을 정리하고, 부족한 정보만 여쭤볼게요. 정보가 모두 모이면 「견적 요청 제출」을 눌러 주세요.',
  'journeyCopy.adjust': '이 견적 요청에 대해 문의하기',
  'journeyCopy.askAdditionalRequirements': '인증, 검사 등 다른 특별 요청이 있으신가요? 없으면 바로 진행하셔도 됩니다.',
  'journeyCopy.askCustomPack': '맞춤 크기, 로고 인쇄, 화인이 필요하신가요? 지금 설명해 주셔도 되고, 아직 정해지지 않았다면 「나중에 추가」를 선택하고 계속 진행하세요.',
  'journeyCopy.askDeliveryDate': '언제 도착하길 원하시나요? 날짜를 선택하거나, 최대한 빨리 또는 일정이 유연하다고 알려 주세요.',
  'journeyCopy.askInnerPack': '박스 안 내포장은 어떤 것을 원하시나요? 하나를 고르거나 일반적인 포장안 비교를 요청하세요.',
  'journeyCopy.askNetWeight': '어떤 외포장을 원하시나요? 잘 모르시면 일반 수출용 종이 박스로 견적을 드립니다.',
  'journeyCopy.askOuterPack': '외박스 1개당 순중량은 얼마로 할까요?',
  'journeyCopy.askOuterPackaging': '어떤 외포장을 원하시나요? 적합 여부는 상품 특성과 콜드체인 방식에 따라 확인합니다.',
  'journeyCopy.askPackAllocation': '이 포장 구성들을 한 주문에 혼합할까요, 아니면 각각 견적을 받은 뒤 결정할까요?',
  'journeyCopy.askPackAllocationDetails': '선택한 포장 구성별로 필요한 박스 수를 입력해 주세요. 합계가 요청 수량과 맞는지 확인합니다.',
  'journeyCopy.askSpec': '어떤 품종과 규격을 원하시나요? 아래에서 선택하거나 다른 규격을 직접 입력하세요. 아직 모르시면 건너뛰어도 됩니다.',
  'journeyCopy.askTerm': '어떤 무역 조건으로 견적을 받으시겠어요? FOB, CFR, CIF 중에서 고르거나 가능한 조건 비교를 요청하세요.',
  'journeyCopy.askTransport': '운송 관련 선호가 있으신가요? 적합한 안을 준비하는 데 도움이 되며, 실제 항로는 견적 시 확정됩니다.',
  'journeyCopy.assistant': '블루',
  'journeyCopy.chooseDate': '날짜 선택',
  'journeyCopy.close': '닫기',
  'journeyCopy.compareStandardPack': '일반적인 포장안 비교',
  'journeyCopy.confirm': '견적 요청 제출',
  'journeyCopy.conversation': '견적 상담',
  'journeyCopy.dateAsap': '최대한 빨리',
  'journeyCopy.dateFlexible': '일정 유연',
  'journeyCopy.dateLabel': '희망 도착일',
  'journeyCopy.delivery': '희망 도착일',
  'journeyCopy.destCountryLabel': '도착 국가',
  'journeyCopy.destPortLabel': '도착항 (선택)',
  'journeyCopy.destination': '도착지',
  'journeyCopy.doing': '견적을 준비하고 있습니다',
  'journeyCopy.done': '완료',
  'journeyCopy.edit': '정보 수정',
  'journeyCopy.eyebrow': '견적 요청',
  'journeyCopy.greeting': '안녕하세요! 필요한 상품을 말씀해 주시면 견적 요청에 필요한 정보를 정리해 드릴게요.',
  'journeyCopy.inquiryNo': '견적 요청 번호',
  'journeyCopy.live': '요청 정보',
  'journeyCopy.login': '로그인',
  'journeyCopy.loginFirst': '견적 요청을 제출하려면 로그인해 주세요',
  'journeyCopy.networkError': '문제가 발생했습니다. 잠시 후 다시 시도해 주세요.',
  'journeyCopy.notNow': '나중에',
  'journeyCopy.openFull': '전체 견적 및 비용 내역 보기',
  'journeyCopy.optional': '선택',
  'journeyCopy.orderBody': '주문이 생성되었습니다. 주문 상세 페이지에서 모든 이행 단계와 실시간 콜드체인 온도를 확인할 수 있습니다.',
  'journeyCopy.orderTitle': '주문 확정',
  'journeyCopy.packCompare': '각각 견적을 받고 나중에 결정',
  'journeyCopy.packComplete': '포장 선호를 기록했습니다. 아래에서 전체 요청 내용을 확인하고 필요하면 더 추가하세요.',
  'journeyCopy.packDescribe': '요청이 있어요, 직접 설명할게요',
  'journeyCopy.packLater': '나중에 추가',
  'journeyCopy.packMixed': '이번 주문에 혼합',
  'journeyCopy.packNoRequirement': '기타 요청 없음',
  'journeyCopy.packOther': '기타 (직접 입력)',
  'journeyCopy.packSkip': '아직 모름',
  'journeyCopy.packaging': '포장',
  'journeyCopy.packagingLabel': '포장 메모 (선택)',
  'journeyCopy.parseFail': '방금 메시지를 처리하지 못했습니다. 다르게 표현해 주시겠어요? (예: 「20톤」)',
  'journeyCopy.pending': '눌러서 추가',
  'journeyCopy.placeholder': '예: 배추 20톤을 11월 전까지 두바이로 받고 싶어요…',
  'journeyCopy.privacy': '검토하고 확인한 후에만 요청이 제출됩니다.',
  'journeyCopy.product': '상품',
  'journeyCopy.productPick': '상품 검색…',
  'journeyCopy.productRequired': '상품명 또는 설명을 입력해 주세요',
  'journeyCopy.progress': '핵심 정보를 채우고 확인한 뒤 제출하세요.',
  'journeyCopy.qtyLabel': '수량',
  'journeyCopy.quantity': '수량',
  'journeyCopy.quoteNo': '견적 번호',
  'journeyCopy.quoteReady': '견적이 준비되었습니다',
  'journeyCopy.quoteSub': 'Bluplanet 발행 · 주문 전에 확인해 주세요',
  'journeyCopy.quoteTitle': '견적 상세',
  'journeyCopy.quoteWaiting': '견적을 준비하고 있습니다. 준비되면 여기에 표시되니 나중에 다시 확인해 주세요.',
  'journeyCopy.ready': '요청 정보가 정리되었습니다. 확인해 주세요',
  'journeyCopy.readyNote': '정보가 모두 모였습니다. 카드를 확인하고 「견적 요청 제출」을 눌러 주세요.',
  'journeyCopy.refine': '제출 전에 모든 항목을 확인하고 수정할 수 있습니다.',
  'journeyCopy.refresh': '새로고침',
  'journeyCopy.sample': '배추 약 20톤을 11월 전까지 두바이로 받고 싶어요.',
  'journeyCopy.send': '보내기',
  'journeyCopy.specLabel': '규격',
  'journeyCopy.start': '견적 요청 시작',
  'journeyCopy.step1': '요청 설명',
  'journeyCopy.step2': '세부 정보',
  'journeyCopy.step3': '요청 제출',
  'journeyCopy.step4': '견적 확인',
  'journeyCopy.step5': '주문',
  'journeyCopy.submitting': '제출 중…',
  'journeyCopy.subtitle': '필요한 상품을 설명해 주세요. 가격과 납품 조건을 확인한 후 주문 여부를 결정하시면 됩니다.',
  'journeyCopy.summary': '요청 내용',
  'journeyCopy.termCompare': '잘 모르겠어요 — FOB, CFR, CIF 안을 비교해 주세요',
  'journeyCopy.termLabel': '무역 조건',
  'journeyCopy.termRecorded': '무역 조건 선호를 기록했습니다. 아래에서 전체 요청 내용을 확인하고 필요하면 더 추가하세요.',
  'journeyCopy.terms': '계약금 30% · 서류 인도 시 70%',
  'journeyCopy.title': '필요한 상품을 알려 주세요',
  'journeyCopy.total': '총액',
  'journeyCopy.transportCost': '비용이 가장 중요',
  'journeyCopy.transportFast': '가능한 빠른 납기 우선',
  'journeyCopy.transportFewTransfers': '환적 최소화',
  'journeyCopy.transportNone': '선호 없음 — 가장 적합한 안으로 진행해 주세요',
  'journeyCopy.transportRecorded': '알겠습니다. 운송 선호로만 반영하며, 확정 항로·소요 기간·비용은 견적과 함께 안내해 드립니다.',
  'journeyCopy.trust': '모든 단계를 직접 확인',
  'journeyCopy.trustBody': '확인하기 전에는 아무것도 전송되지 않습니다.',
  'journeyCopy.unitPrice': '단가',
  'journeyCopy.useEarliestDate': '가장 빠른 예상일 사용',
  'journeyCopy.verified': '가격, 납품, 결제 조건을 확인하세요',
  'journeyCopy.viewInquiries': '내 견적 요청',
  'journeyCopy.viewOrder': '주문 상세 및 실시간 온도 보기',
  'journeyCopy.viewOrders': '내 주문',
  'journeyCopy.you': '나',
  'lang.switch': '언어 변경',
  'message.content.INQUIRY_REPLY': '견적 요청 {inquiryNo}에 견적서 {quoteNo}가 회신되었습니다. 「내 견적 요청」에서 확인 후 주문해 주세요.',
  'message.content.INQUIRY_SUBMITTED': '견적 요청 {inquiryNo}이(가) 제출되었습니다 (품목 {count}개). 무역 담당자가 곧 정식 견적을 보내드립니다.',
  'message.content.ORDER_CREATED': '견적서 {quoteNo}가 확정되어 주문 {orderNo}이(가) 생성되었습니다. 「내 주문」에서 확인하세요.',
  'message.content.QUOTE_ACCEPTED': '견적서 {quoteNo}를 확인하셨습니다. 「내 견적 요청」에서 주문으로 전환할 수 있습니다.',
  'nav.requestAQuote': '견적 요청',
  'product.iDLikeAQuote': '{productName}{v} 견적을 요청합니다.',
  'profile.descForce': '견적 요청 전에 회사 정보를 등록해 주세요. 공급업체가 귀사를 확인하는 데 필요합니다.',
  'progress.addAttachment': '첨부파일 추가',
  'progress.advisor': '담',
  'progress.attachJpgPngPdfDoc': 'JPG, PNG, PDF, DOC, XLS 파일을 첨부할 수 있습니다.',
  'progress.availableQuoteOptions': '선택 가능한 견적안 ({v})',
  'progress.backToInquiries': '내 견적 요청으로 돌아가기',
  'progress.blu': '블',
  'progress.conversationUpdates': '상담 기록 및 진행 상황',
  'progress.couldNotLoadThisInquiry': '견적 요청을 불러오지 못했습니다.',
  'progress.couldNotStartVoiceRecognition': '음성 인식을 시작할 수 없습니다.',
  'progress.eachFileMustBe10': '파일당 10MB 이하여야 합니다.',
  'progress.goodsTotal': '상품 대금',
  'progress.inquiryNotFound': '견적 요청을 찾을 수 없습니다.',
  'progress.loading': '불러오는 중…',
  'progress.messageNotSentTryAgain': '메시지를 보내지 못했습니다. 다시 시도해 주세요.',
  'progress.messageYourAdvisor': '담당자에게 메시지 보내기…',
  'progress.myInquiries': '내 견적 요청',
  'progress.needBy': '희망 도착일',
  'progress.noMessagesYet': '아직 상담 기록이 없습니다.',
  'progress.onlyTheFirstFilesWere': '첨부는 최대 6개까지이며, 앞의 6개만 추가되었습니다.',
  'progress.packaging': '포장/메모',
  'progress.pressAndHoldToSpeak': '길게 눌러 말하기',
  'progress.previewAttachment': '첨부파일 미리보기',
  'progress.quoteDetailsAreBeingUpdated': '견적 내용을 업데이트하고 있습니다. 잠시 후 새로고침해 주세요.',
  'progress.quoteOption': '견적안',
  'progress.quoteRequest': '견적 요청',
  'progress.recognizing': '인식 중',
  'progress.referenceSailingTimeAboutSailingdays': '참고 항해 기간: 약 {sailingDays}일',
  'progress.releaseToFinish': '손을 떼면 종료',
  'progress.releaseToFinishSpeaking': '손을 떼면 음성 입력 종료',
  'progress.requestDetails': '요청 내용',
  'progress.reviewThisOption': '견적안 상세 보기',
  'progress.sendMessage': '메시지 보내기',
  'progress.status.ORDERED': '주문 완료',
  'progress.status.PENDING': '접수 대기',
  'progress.status.PROCESSING': '처리 중',
  'progress.status.QUOTED': '견적 완료',
  'progress.status.WITHDRAWN': '철회됨',
  'progress.step1': '요청 설명',
  'progress.step2': '확인 및 제출',
  'progress.step3': '요청 처리 중',
  'progress.step4': '견적 확인',
  'progress.step5': '주문',
  'progress.termScope.CFR': '지정 도착항까지의 국제 운임 포함',
  'progress.termScope.CIF': '지정 도착항까지의 국제 운임과 보험료 포함',
  'progress.termScope.DDP': '수입 통관, 세금, 배송 범위는 견적 상세를 확인하세요',
  'progress.termScope.EXW': '공장 인도 조건이며, 인수 후 운송 및 비용은 바이어가 부담합니다',
  'progress.termScope.FOB': '지정 선적항까지의 견적이며, 국제 운임과 보험은 별도입니다',
  'progress.text': ', ',
  'progress.thisMessageWillBeAdded': '메시지는 이 견적 요청에 저장되며, 담당자가 확인 후 답변합니다.',
  'progress.tradeTerm': '무역 조건',
  'progress.upTo6FilesCan': '최대 6개 파일까지 첨부할 수 있습니다.',
  'progress.validValiddaysDays': '{validDays}일간 유효',
  'progress.view5StepProgress': '5단계 진행 상황 보기',
  'progress.voiceRecognitionFailedPleaseTry': '음성 인식에 실패했습니다. 다시 시도하거나 직접 입력해 주세요.',
  'progress.voiceTypingIsNotAvailable': '이 브라우저에서는 음성 입력을 지원하지 않습니다. 직접 입력해 주세요.',
  'progress.you': '나',
  'quote.backToQuoteOptions': '견적안으로 돌아가기',
  'quote.cartonRemainder': ' (잔여 {kg}kg)',
  'quoteUnit.CASE': '박스',
  'quoteUnit.KG': 'kg',
  'quoteUnit.PIECE': '개',
  'quoteUnit.TON': '톤',
  'service.endToEndSupportFor': '글로벌 농산물 거래를 처음부터 끝까지 지원합니다.',
  'unit.case': '박스',
  'unit.kg': 'kg',
  'unit.piece': '개',
  'unit.ton': '톤',
  'login.toRegister': '계정이 없으신가요? 회원가입',
  'journey.allocatedAbout': ' / 총 약 {n}박스',
};
